(function () {
	'use strict';

	angular
		.module('ProjectModule')
		.controller('ProjectController', ProjectController);

	ProjectController.$inject = [
		'$scope',
		'$rootScope',
		'ProjectService',
		'$stateParams',
		'toaster',
		'gettextCatalog',
		'$timeout',
		'$state',
		'UserService',
		'ContextServices',
		'DateService',
		'PermissionService',
		'AppSelectorService',
		'ModalService',
		'GLOBAL_PERMISSION_CODES',
	];

	function ProjectController(
		$scope,
		$rootScope,
		ProjectService,
		$stateParams,
		toaster,
		gettextCatalog,
		$timeout,
		$state,
		UserService,
		ContextServices,
		DateService,
		PermissionService,
		AppSelectorService,
		ModalService,
		GLOBAL_PERMISSION_CODES
	) {
		$scope.dataModel = {};
		$scope.metadata = {};
		$scope.htmlEditor = {};
		$scope.metadata.actif = true;
		$scope.metadata.tags = [];
		$scope.savingInProgress = false;
		$scope.datePattern = 'DD/MM/YYYY HH:mm';
		$scope.permissionData = {};
		$scope.permissionData = {};
		$scope.selectedItem = null;
		$scope.searchText = null;
		$scope.projectId = $stateParams.projectId;
		$scope.selectedUsers = [];
		$scope.autocompleteDemoRequireMatch = false;
		$scope.usersLoaded = false;
		$scope.querySearch = querySearch;
		$scope.queryMemberSearch = queryMemberSearch;
		$scope.queryCurrentMemberSearch = queryCurrentMemberSearch;
		$scope.transformChip = transformChip;
		$scope.loadMailsTemplate = loadMailsTemplate;
		$scope.project = {
			members: [],
			contexts: [],
			creator_permission_template: {},
			member_permission_template: {},
			selectedTab: 0,
			navigation_links: [{ label: 'Pydc', url: '' }],
			advanced_params: { critical: true },
		};
		$scope.dataModel.save = $scope.saveAndReturnToList;
		$scope.exposuresCodePattern =
			/^(\/)?([a-zA-Z0-9\-\.\/\_~\:\@\!\$\&\'\(\)\*\+\,\;\=]*)$/;
		$scope.disabledUserTooltip = gettextCatalog.getString('user.disabled');

		let toasterPopSuccess = gettextCatalog.getString('Succès');
		let toasterPopCreationProject = gettextCatalog.getString(
			'project.creation.done'
		);
		let toasterPopModificationProject = gettextCatalog.getString(
			'project.modification.done'
		);

		init();

		$scope.saveAndReturnToList = function () {
			$scope.saveProject(true);
		};

		$scope.changeMember = function (item) {
			if ($scope.permissionData.reload) {
				$scope.permissionData.reload();
			}
		};

		$scope.selectUser = function (item) {
			if (item === null || item === undefined) {
				return;
			}
			$scope.selectedUsers.push({
				id: item.id,
				name: item.name,
				enabled: item.enabled,
				active: true,
				has_project_role: item.has_project_role,
				has_member_role: item.has_member_role,
				is_group: item.is_group,
				admin: false,
			});
		};

		$scope.deleteMember = function (item) {
			$scope.selectedUsers.splice($scope.selectedUsers.indexOf(item), 1);
		};

		$scope.validateTemplate = function (open) {
			$scope.project.selectedTab = open;
		};

		$scope.validateMembers = function (open) {
			$scope.project.selectedTab = open;
		};

		$scope.validateStatuses = function (open) {
			$scope.project.selectedTab = open;
		};

		$scope.validateContexts = function (open) {
			$scope.project.selectedTab = open;
		};

		$scope.linkChange = function (newVal) {
			$scope.justTheOnePyDcLink = newVal;
		};

		$scope.validateAdvancedParams = function (open) {
			$scope.project.selectedTab = open;
		};

		$scope.saveAll = function () {
			$scope.saveProject();
		};

		$scope.saveProject = function () {
			// Validation
			if (!validateProject($scope.project) || $scope.projectForm.$invalid) {
					return;
			}
			// Detect root code changes
			const currentRoot = $scope.project.advanced_params ? $scope.project.advanced_params.exposures_root_code : undefined;
			const hasChanged = !$scope.isNew && $scope.initialExposuresRootCode && (currentRoot !== $scope.initialExposuresRootCode);

			if (hasChanged) {
				// Show confirmation msg
				ModalService.confirm({
						title: gettextCatalog.getString('project.save.confirmation.modal.title'),
						content: gettextCatalog.getString('project.save.confirmation.modal.body'),
						acceptLabel: gettextCatalog.getString('project.save.confirmation.modal.confirm'),
						cancelLabel: gettextCatalog.getString('project.save.confirmation.modal.cancel')
				}).then(function() {
						executeSave();
				});
			} else {
				// No change save
				executeSave();
			}
		};

		$scope.showDuplicateModal = function () {
			checkIfNoOperationIsRunningAndOpen(true);
		};

		$scope.showExportModal = function () {
			checkIfNoOperationIsRunningAndOpen(false);
		};

		function checkIfNoOperationIsRunningAndOpen(isDuplication) {
			ProjectService.isAnyExecutionRunning().then(function (response) {
				if (!response.data) {
					if (isDuplication) {
						$scope.elementData = true;
					} else {
						$scope.datas = true;
					}
				} else {
					toaster.pop(
						'error',
						gettextCatalog.getString('project.bulk.execution.in.progress')
					);
				}
			});
		}

		function loadMailsTemplate() {
			$scope.mailsTemplatesLoaded = false;
			$timeout(function () {
				$scope.mailsTemplatesLoaded = true;
			}, 20);
		}

		function init() {
			$scope.isNew = true;
			$scope.savingInProgress = false;
			$scope.mailsTemplatesLoaded = false;
			$scope.justTheOnePyDcLink = '';
			$scope.mailTemplatesKeys = [];
			$scope.mailTemplatesReady = false;
			if ($stateParams.projectId) {
				$scope.isNew = false;
				$scope.projectId = $stateParams.projectId;
				$scope.metadata.isNew = false;
				ProjectService.getProject($scope.projectId).then(function (response) {
					$scope.project = response.data;
					let projectLink =
						$scope.project.project_links && $scope.project.project_links[0]
							? $scope.project.project_links[0].link_url
							: '';
					$scope.justTheOnePyDcLink = projectLink;
					if ($scope.project.advanced_params && $scope.project.advanced_params.exposures_root_code) {
						$scope.initialExposuresRootCode = $scope.project.advanced_params.exposures_root_code;
					}

					$timeout(function () {
						$rootScope.$broadcast('project:link-update', projectLink);
					}, 2000);

					$scope.project.effect_date = DateService.dateToStringWithPatternLocal(
						$scope.project.effect_date,
						$scope.datePattern
					);
					$scope.project.expiration_date =
						DateService.dateToStringWithPatternLocal(
							$scope.project.expiration_date,
							$scope.datePattern
						);
					$scope.metadata = $scope.project.metadata;
					$scope.projectLib = $scope.metadata.label;
					$scope.metadataLoaded = true;

					getAllUsers(function () {
						const members = $scope.project.members;
						for (let m in members) {
							let user = _.find($scope.users, function (item) {
								return item.id === members[m].member_id;
							});
							if (user) {
								$scope.selectedUsers.push({
									id: user.id,
									name: user.name,
									admin: members[m].admin,
									active: members[m].active,
									enabled: user.enabled,
									is_group: user.is_group,
									has_project_role: user.has_project_role,
									has_member_role: user.has_member_role,
								});
							}
						}
						$scope.currentMembers = angular.copy($scope.selectedUsers);
					});

					getAllContexts(function () {
						for (let c in $scope.project.contexts) {
							let ctx = _.find($scope.contexts, function (item) {
								return item.id === $scope.project.contexts[c].context_id;
							});
							if (ctx) {
								ctx.jobs = $scope.project.contexts[c].jobs;
								ctx.persistence = $scope.project.contexts[c].persistence;
							}
						}
					});

					ProjectService.getProjectLastAccessDates($scope.projectId).then(
						function (responseL) {
							$scope.lastAccessDates = responseL.data;
							for (let u in $scope.lastAccessDates) {
								$scope.lastAccessDates[u] = $rootScope.getDateTimeWithPatternMn(
									$scope.lastAccessDates[u]
								);
							}
						}
					);

					getMailTemplates();

					// check if the user has public project creation permission
					const ignoreMemberRole = true;
					PermissionService.haveGlobalPermission(
						GLOBAL_PERMISSION_CODES.public_project_create,
						ignoreMemberRole
					).then(function (response) {
						if (!response.data && !$scope.project.is_public) {
							$scope.disablePublicProjectCreation = true;
						}
					});
				});
			} else {
				$scope.opened = 'A';
				$scope.metadataLoaded = true;
				$scope.disablePublicProjectCreation = false;
				// default dates
				let nowDate = new Date();
				$scope.project.effect_date = DateService.dateToStringWithPatternLocal(
					nowDate,
					$scope.datePattern
				);
				$scope.project.expiration_date =
					DateService.getRevocationDateWithPattern(
						$scope.project.expiration_date,
						$scope.datePattern
					);
				getAllUsers();
				getAllContexts();

				// check if the user has public project creation permission
				const ignoreMemberRole = true;
				PermissionService.haveGlobalPermission(
					GLOBAL_PERMISSION_CODES.public_project_create,
					ignoreMemberRole
				).then(function (response) {
					if (!response.data) {
						$scope.project.is_public = false;
						$scope.disablePublicProjectCreation = true;
					}
				});
			}
		}

		function getAllUsers(action) {
			$scope.usersLoaded = false;
			UserService.getProjectMembers().then(function (members) {
				$scope.users = members.filter((member) => member.has_member_role);
				if (action) {
					action();
				}
				$scope.usersLoaded = true;
			});
		}

		function getAllContexts(action) {
			ContextServices.getContextList(true).then(function (response) {
				$scope.contexts = response.data;
				if (action) {
					action();
				}
			});
		}

		function getMailTemplates() {
			$scope.mailTemplatesReady = false;
			ProjectService.getDefaultMailsTemplates().then(function (templateResp) {
				let data = templateResp.data;
				if (
					!$scope.project.advanced_params.emails_templates ||
					Object.keys($scope.project.advanced_params.emails_templates).length ==
						0
				) {
					$scope.project.advanced_params.emails_templates = data;
				} else {
					for (let key in data) {
						if (
							!$scope.project.advanced_params.emails_templates.hasOwnProperty(
								key
							)
						) {
							$scope.project.advanced_params.emails_templates[key] = data[key];
						}
					}
				}
				// get mails templates keys
				$scope.mailTemplatesKeys = getMailsTemplatesKeysFromProjectObg();
				$scope.mailTemplatesReady = false;
			});
		}

		function validateProject(project) {
			if (
				!_.filter($scope.contexts, function (item) {
					return item.persistence;
				})[0]
			) {
				toaster.pop(
					'error',
					gettextCatalog.getString(
						'Un contexte Persistance/Extraction/Export est obligatoire'
					)
				);
				return false;
			}
			if (
				!_.filter($scope.contexts, function (item) {
					return item.jobs;
				})[0]
			) {
				toaster.pop(
					'error',
					gettextCatalog.getString(
						'Un contexte Autres activités est obligatoire'
					)
				);
				return false;
			}
			const atLeastOneAdminIsFound = $scope.selectedUsers.some(
				(it) => it.admin && it.active
			);
			if (!atLeastOneAdminIsFound) {
				toaster.pop(
					'error',
					gettextCatalog.getString('Un administrateur est obligatoire')
				);
				return false;
			}
			if (
				project.expiration_date &&
				project.effect_date &&
				moment(project.effect_date).isAfter(moment(project.expiration_date))
			) {
				toaster.pop('error', gettextCatalog.getString('date.effect.error'));
				return false;
			}
			return true;
		}

		function catchProjectSaveErrors(error) {
			if (error.data.code === '52') {
				$scope.project.is_public = true;
			}
			$scope.savingInProgress = false;
		}

		/**
		 * Return the proper object when the append is called.
		 */
		function transformChip(chip) {
			// If it is an object, it's already a known chip
			if (angular.isObject(chip)) {
				return chip;
			}

			// Otherwise, create a new one
			return {
				name: chip,
				type: 'new',
			};
		}

		/**
		 * Search for users.
		 */
		function querySearch(query) {
			return query
				? $scope.users
						.filter((user) => user.enabled)
						.filter(
							(user) =>
								user.name.toLowerCase().indexOf(query.toLowerCase()) > -1
						)
						.filter(
							(user) =>
								!_.find($scope.selectedUsers, function (item) {
									return item.id == user.id;
								})
						)
				: [];
		}

		/**
		 * Search for users.
		 */
		function queryMemberSearch(query) {
			return query
				? $scope.selectedUsers.filter(
						createMembersFilterFor(query, $scope.selectedUsers)
				  )
				: [];
		}

		/**
		 * Search for current members.
		 */
		function queryCurrentMemberSearch(query) {
			return query
				? $scope.currentMembers.filter(
						createMembersFilterFor(query, $scope.currentMembers)
				  )
				: [];
		}

		/**
		 * Create filter function for a query string
		 */
		function createMembersFilterFor(query, users) {
			return function filterFn(user) {
				return (
					_.find($scope.selectedUsers, function (item) {
						return item.id == user.id;
					}) && user.name.toLowerCase().indexOf(query.toLowerCase()) > -1
				);
			};
		}

		function getMailsTemplatesKeysFromProjectObg() {
			let keys = Object.keys($scope.project.advanced_params.emails_templates);
			$scope.selectedKey = keys[0] ? keys[0] : null;
			$scope.mailsTemplatesLoaded = true;

			return keys.map((v) => {
				return {
					key: v,
					label: gettextCatalog.getString(
						'project.mail.template.scopes.key.' + v.toLowerCase()
					),
					title: gettextCatalog.getString(
						'project.mail.template.scopes.key.' + v.toLowerCase() + '.title'
					),
				};
			});
		}

			/**
			 * Logique technique de formatage et appel au service de sauvegarde
			 */
			function executeSave() {
				let projectUpdate = angular.copy($scope.project);

				// Formatage des dates pour l'API
				projectUpdate.effect_date = DateService.getDateInIsoFormat(projectUpdate.effect_date);
				projectUpdate.expiration_date = DateService.getDateInIsoFormat(projectUpdate.expiration_date);

				// Formatage des membres
				projectUpdate.members = [];
				const users = $scope.selectedUsers;
				for (let u in users) {
					projectUpdate.members.push({
						member_id: users[u].id,
						admin: !!users[u].admin,
						active: !!users[u].active,
						is_group: users[u].is_group,
					});
				}

				// Formatage des contextes
				projectUpdate.contexts = [];
				for (let c in $scope.contexts) {
					if ($scope.contexts[c].persistence || $scope.contexts[c].jobs) {
						projectUpdate.contexts.push({
								context_id: $scope.contexts[c].id,
								persistence: $scope.contexts[c].persistence,
								jobs: $scope.contexts[c].jobs,
						});
					}
				}

				projectUpdate.is_public = !!projectUpdate.is_public;

				// Formatage des métadonnées
				for (var t in $scope.metadata.tags) {
					$scope.metadata.tags[t].color = $scope.metadata.tags[t].color || '#dbf5d1';
				}

				projectUpdate.metadata = {
					active: $scope.metadata.actif,
					tags: $scope.metadata.tags,
					licence_type: $scope.metadata.licence_type,
					icon_id: $scope.metadata.icon_id,
					short_label: $scope.metadata.label,
					description: $scope.metadata.description,
					code: $scope.metadata.code
				};

				projectUpdate.navigation_links = [
					{ label: 'Pydc', url: $scope.justTheOnePyDcLink },
				];

				// Formatage des paramètres avancés
				projectUpdate.advanced_params = {
					exposures_root_code: projectUpdate.advanced_params ? projectUpdate.advanced_params.exposures_root_code : undefined,
					emails_templates: projectUpdate.advanced_params ? projectUpdate.advanced_params.emails_templates : null,
					critical: projectUpdate.advanced_params ? projectUpdate.advanced_params.critical : true,
				};

				$scope.savingInProgress = true;

				// Appel du service (Création ou Édition)
				let servicePromise = $scope.isNew
					? ProjectService.createProject(projectUpdate)
					: ProjectService.editProject($stateParams.projectId, projectUpdate);

				servicePromise
					.then(function (response) {
						const msg = $scope.isNew ? toasterPopCreationProject : toasterPopModificationProject;
						toaster.pop('success', toasterPopSuccess, msg);

						$timeout(function () {
								$scope.savingInProgress = false;
								$state.go('projects');
						}, 300);
					})
					.catch(function(error) {
						catchProjectSaveErrors(error);
						$scope.savingInProgress = false;
					});

				// Mise à jour du sélecteur d'application si c'est le projet courant
				if ($stateParams.projectId === AppSelectorService.getSelectedProjectId()) {
					AppSelectorService.setSelectedProject($stateParams.projectId, $scope.metadata.label);
					$rootScope.$broadcast('update:project:selection');
				}
			}
	}
})();
